import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  fileName: string;
}

export const useDownloadOriginalFileFromCloud = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, fileName }: HookProps) => {
      const result = await apiClient.batchesCore.downloadBatch.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;

      const href = window.URL.createObjectURL(result.body as Blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully downloaded the original file!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the original file!');
    },
  });
};
